export default __webpack_public_path__ + "76b37f868355e1a32ac8be668c2a0d2c.png";